import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    selector: "im-finish-inspection-dialog",
    templateUrl: "./finish-inspection-dialog.component.html",
    styleUrls: ["./finish-inspection-dialog.component.scss"],
    standalone: false
})
export class FinishInspectionDialogComponent implements OnInit {
  public title: string;
  public text: string;
  public inspectionResult: string;
  public inspectionResultSelected: boolean = false;

  public options: string[] = ["Pass", "Fail", "N/A", "Information required"];

  constructor(
    private dialogRef: MatDialogRef<FinishInspectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData: any,
  ) {}

  ngOnInit(): void {
    this.title = this.dialogData.hasInspectors
      ? "Unfinished jobs"
      : "Finish Inspection";
    this.text = this.dialogData.hasInspectors
      ? 'There are inspectors pending to finish this operation on their devices.<br><br>Are you sure that you want to set this Inspection as "Finished" on their behalf?'
      : 'Do you want to set this inspection as "Finished"?';
  }

  updateInspectionResult(result): void {
    this.inspectionResult = result;
    if (this.inspectionResult) {
      this.inspectionResultSelected = true;
    } else {
      this.inspectionResultSelected = false;
    }
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  finish(): void {
    this.dialogRef.close({
      inspectionResult: this.inspectionResult,
    });
  }
}
